import { AutoMap } from '@automapper/classes';

export class AreaMapEntity {
    @AutoMap()
    Id?: number;
    @AutoMap()
    Legend!: string;
    @AutoMap()
    Comment!: string;
    @AutoMap()
    JsonContent?: string;
    @AutoMap()
    BackgroundPicture?: string;
    @AutoMap()
    Data?: string;
}
